import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import CategoriesForm from 'modules/surveys/components/Form/QuestionCategories/CategoriesForm'
import type QuestionCategory from 'modules/surveys/store/models/QuestionCategory'
import type QuestionsTemplateCategory from 'modules/surveys/store/models/QuestionsTemplateCategory'

interface Props {
  onClose: () => void
  onSubmit: (data: Record<string, unknown>) => Promise<unknown>
  category: QuestionCategory | QuestionsTemplateCategory
}

export default function EditCategoryModal({ onClose, onSubmit, category }: Props) {
  return (
    <CategoriesForm
      modalIllustration="add-block"
      modalTitle={i18n.t('surveys.form.question_categories.edit.title')}
      modalDescription={i18n.t('surveys.form.question_categories.edit.description')}
      modalLabel={i18n.t('surveys.form.question_categories.edit.label')}
      modalPlaceholder={i18n.t('surveys.form.question_categories.edit.label_placeholder')}
      modalButton={i18n.t('surveys.form.question_categories.edit.submit')}
      category={category}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}
